import React from 'react';
import {
  HintText,
  NotificationButtonContainer,
  NotificationContainer,
} from 'app/components/banner/NotificationHintStyles';
import {useTheme} from '@mui/styles';
import {Warning} from '@mui/icons-material';
import {FlexContainer} from 'app/styles/content';
import styled from 'styled-components';
import {Button} from '@mui/material';

const SCNotificationContainer = styled(NotificationContainer)`
  margin: 0.5rem 1rem 0;
  border-radius: 0.25rem;
  padding-top: 0.625rem;
  a {
    text-decoration: underline;
    color: inherit;
    cursor: pointer;
  }
`;

const SCWarning = styled(Warning)`
  margin-right: 0.75rem;
`;

const DMHint = ({text, action}) => {
  const {palette} = useTheme();

  const actionButton = action ? <DMHintButton primaryAction={action} /> : null;

  return (
    <SCNotificationContainer color={palette.warning.light}>
      <FlexContainer>
        <SCWarning color='inherit' fontSize='inherit' />
        <HintText variant='body1'>{text}</HintText>
      </FlexContainer>
      {actionButton}
    </SCNotificationContainer>
  );
};

const DMHintButton = ({primaryAction}) => {
  return (
    <NotificationButtonContainer justify='flex-end'>
      <Button color='inherit' onClick={primaryAction.action}>
        {primaryAction.label}
      </Button>
    </NotificationButtonContainer>
  );
};

export {DMHint};
